import React, { Component } from 'react'

import './index.scss'

class Footer extends Component {
    render() {
        return (
            <div className="Footer">
                <p>
                    Copyright © 2000 - 2022 XINHUANET.com　All Rights Reserved.
                </p>
                <p>
                    制作单位：新华网股份有限公司　　版权所有：新华网股份有限公司
                </p>
            </div>
        )
    }
}

export default Footer
